import React, { useState, useEffect } from 'react';

import { Box, Button, Grid, Breadcrumbs, Link, Tooltip, Typography, Select, MenuItem, TextField, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoomMaster, getRoomMasterData, getdrpRoomView } from '../../../Api/RoomMst/Api';
import { getRoomMasterdropdata, GetBedCalendarMonthwise, GetPropWiseBedCalendarMonth, updatebedcalender } from '../../../Api/PropertyMst/Api'
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { getFormMode } from "../../../lib/helpers";
import TableComponent from "../../../atoms/TableComponent/Operations(Bedreports)table";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import CrudButtons from '../../../GlobalFunction/CrudButtons'
import { Delete as DeleteIcon } from '@mui/icons-material'

const Form_Mode = getFormMode();

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]

const BASE_COLUMNS = [
  { id: 'RoomNo', label: 'RoomNo', minWidth: 60 },
  { id: 'RoombedName', label: 'BedNo', minWidth: 60 },
  { id: 'RoomTypeName', label: 'RType', minWidth: 60 },
  { id: 'RoomBedTypeName', label: 'BType', minWidth: 60 },
  { id: 'RoomViewNAme', label: 'View', minWidth: 60 },
];

const generateColumns = (startDate, endDate) => {
  const baseColumnWidths = {
    RoomNo: 50,
    RoombedName: 500,
    RoomTypeName: 50,
    RoomBedTypeName: 50,
    RoomViewNAme: 50
  };

  const baseColumns = BASE_COLUMNS.map(col => ({
    ...col,
    minWidth: baseColumnWidths[col.id],
    maxWidth: baseColumnWidths[col.id],
    width: baseColumnWidths[col.id]
  }));

  // Generate array of months between start and end date
  const columns = [];
  let currentDate = dayjs(startDate).startOf('month');
  const endMonth = dayjs(endDate).endOf('month');

  while (currentDate.isBefore(endMonth) || currentDate.isSame(endMonth, 'month')) {
    const year = currentDate.year();
    const month = MONTHS[currentDate.month()];

    // Add year column if it's January or the first month in range
    if (currentDate.month() === 0 || currentDate.isSame(startDate, 'month')) {
      columns.push({
        id: `year_${year}`,
        label: 'Year',
        minWidth: 20,
        maxWidth: 20,
        width: 20
      });
    }

    columns.push({
      id: `${year}_${month}`,
      // label: month,
      label: month.substring(0, 3),
      minWidth: 20,
      maxWidth: 20,
      width: 20
    });

    currentDate = currentDate.add(1, 'month');
  }

  return [...baseColumns, ...columns];
};

const transformData = (apiData, startDate, endDate) => {
  const roomDataMap = new Map();

  // First pass: Organize data by RoomBedId
  apiData.forEach(item => {
    if (!roomDataMap.has(item.RoomBedId)) {
      roomDataMap.set(item.RoomBedId, {
        RoomBedId: item.RoomBedId,
        RoomNo: item.RoomNo,
        RoombedName: item.RoombedName,
        RoomTypeName: item.RoomTypeName,
        RoomBedTypeName: item.RoomBedTypeName,
        RoomViewNAme: item.RoomViewNAme
      });
    }

    const roomData = roomDataMap.get(item.RoomBedId);
    const monthKey = `${item.YearNm}_${MONTHS[item.MonthId - 1]}`;
    roomData[monthKey] = item.BedStatus;

    // Add year data
    const yearKey = `year_${item.YearNm}`;
    roomData[yearKey] = item.YearNm;
  });

  // Convert Map to array and ensure all required columns exist
  const transformedData = Array.from(roomDataMap.values()).map(roomData => {
    const row = { ...roomData };

    // Fill in data for the selected date range
    let currentDate = dayjs(startDate).startOf('month');
    const endMonth = dayjs(endDate).endOf('month');

    while (currentDate.isBefore(endMonth) || currentDate.isSame(endMonth, 'month')) {
      const year = currentDate.year();
      const month = MONTHS[currentDate.month()];

      // Add year column if it's January or first month
      if (currentDate.month() === 0 || currentDate.isSame(startDate, 'month')) {
        const yearKey = `year_${year}`;
        if (!row[yearKey]) {
          row[yearKey] = year;
        }
      }

      // Ensure month column exists
      const monthKey = `${year}_${month}`;
      if (!row[monthKey]) {
        row[monthKey] = '';
      }
      currentDate = currentDate.add(1, 'month');
    }

    return row;
  });

  return transformedData;
};

export default function GenerateCalender(PropId, formMode) {
  const userId = sessionStorage.getItem('UserId');
  const location = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [properties, setProperties] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedPropId, setSelectedPropId] = useState(null);
  const [dateFrom, setDateFrom] = useState(dayjs());
  const [dateTo, setDateTo] = useState(dayjs().add(18, 'months'));
  const [tableColumns, setTableColumns] = useState(generateColumns([dayjs().year()]));
  const [isLoading, setIsLoading] = useState(false);
  const [editableData, setEditableData] = useState(new Map());
  const [selectedRows, setSelectedRows] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [form, setForm] = useState({
    PropId: "",
  });

  const [mode, setMode] = useState(() =>
    location?.state?.RoomId ? Form_Mode.read : Form_Mode.add
  );

  const handleCellEdit = (rowIndex, columnId, newValue, originalValue) => {
    if (!isEditMode || !selectedRows.includes(rowIndex)) return;

    const row = rows[rowIndex];
    const [year, month] = columnId.split('_');

    // Allow empty string while maintaining the original background color
    if (newValue === '') {
      const monthIndex = MONTHS.findIndex(m => m === month) + 1;
      const key = `${rowIndex}-${columnId}`;

      setEditableData(prev => {
        const newMap = new Map(prev);
        newMap.set(`${rowIndex}-${columnId}`, {
          RoomBedId: row.RoomBedId,
          MonthNm: month,
          MonthId: monthIndex,
          YearNm: parseInt(year),
          BedStatus: newValue,
          originalValue: originalValue,
          CreatedBy: parseInt(sessionStorage.getItem('UserId') || '0'),
          originalValue: originalValue // Store original value for background color
        });
        return newMap;
      });

      setRows(prevRows => {
        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          [columnId]: newValue,
          [`${columnId}_original`]: originalValue // Store original value for background
        };
        return newRows;
      });
      return;
    }

    // Validate new value if not empty
    if (newValue !== '' && !['A', 'M', 'R'].includes(newValue.toUpperCase())) {
      toast.error('Only A, M, or R values are allowed');
      return;
    }

    // Normal update process for valid values
    const monthIndex = MONTHS.findIndex(m => m === month) + 1;
    const key = `${rowIndex}-${columnId}`;

    setEditableData(prev => {
      const newMap = new Map(prev);
      newMap.set(key, {
        RoomBedId: row.RoomBedId,
        MonthNm: month,
        MonthId: monthIndex,
        YearNm: parseInt(year),
        BedStatus: newValue.toUpperCase(),
        CreatedBy: parseInt(sessionStorage.getItem('UserId') || '0')
      });
      return newMap;
    });

    setRows(prevRows => {
      const newRows = [...prevRows];
      newRows[rowIndex] = {
        ...newRows[rowIndex],
        [columnId]: newValue.toUpperCase()
      };
      return newRows;
    });
  };

  const getCurrentPermissions = () => {
    if (location.state?.permissions) {
      console.log("State permissions:", location.state.permissions);
      localStorage.setItem('userPermissions', JSON.stringify(location.state.permissions));
      return location.state.permissions;
    }
    const storedPermissions = localStorage.getItem('userPermissions');

    return storedPermissions ? JSON.parse(storedPermissions) : [];
  };

  const currentPermissions = getCurrentPermissions();


  const permissions = useModulePermissions("Bed Reports");
  const { AddRec = "0" } = permissions || {};

  // New function to handle click based on permission
  const handlePermittedClick = () => {
    if (AddRec === "1") {
      handleClick();
    }
  };

  const handleDropdownChange = async (event) => {
    const selectedId = event.target.value;
    setSelectedValue(selectedId);
    setForm(prevForm => ({
      ...prevForm,
      PropId: selectedId
    }));

    // Clear any editing state
    setIsEditMode(false);
    setSelectedRows([]);
    setEditableData(new Map());

    if (!dateFrom || !dateTo) {
      return toast.error("Please select a date range");
    }

    try {
      setIsLoading(true);
      setRows([]);

      const payload = {
        PropId: selectedId,
        BookDtFrom: dateFrom.format("YYYY-MM-DD"),
        CheckoutDt: dateTo.format("YYYY-MM-DD"),
      };

      const response = await GetPropWiseBedCalendarMonth(payload);

      if (response?.data?.Status === 0) {
        const newColumns = generateColumns(dateFrom, dateTo);
        setTableColumns(newColumns);
        const transformedData = transformData(response.data.Data, dateFrom, dateTo);
        setRows(transformedData || []); // Ensure we always set an array
      } else {
        toast.error(response?.data?.Message || "Error fetching data");
      }
    } catch (error) {
      toast.error("Failed to fetch data");
      setRows([]); // Ensure rows is cleared on error
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsEditMode(false);
    setSelectedRows([]);
    setEditableData(new Map());
    // Optionally refresh data to revert changes
    fetchData("");
  };

  const fetchData = async (Flag) => {
    if (!selectedValue || !dateFrom || !dateTo) {
      return toast.error("Please select a property and date range");
    }
    try {
      setRows([]);
      setIsLoading(true);
      const payload = {
        PropId: selectedValue,
        BookDtFrom: dateFrom.format("YYYY-MM-DD"),
        CheckoutDt: dateTo.format("YYYY-MM-DD"),

      };
      const response = await GetPropWiseBedCalendarMonth({ ...payload, Flag });
      if (response?.data?.Status === 0) {
        const years = [...new Set(response.data.Data.map(item => item.YearNm))].sort();
        // setTableColumns(generateColumns(dateFrom, dateTo));
        // const transformedData = transformData(response.data.Data, dateFrom, dateTo);
        // setRows(transformedData);
        const newColumns = generateColumns(dateFrom, dateTo);
        setTableColumns(newColumns);
        const transformedData = transformData(response.data.Data, dateFrom, dateTo);
        setRows(transformedData);
      } else {
        // toast.error("Error fetching data");
      }
    } catch (error) {
      toast.error("Failed to fetch data");
    }
    finally {
      setIsLoading(false);
    }
  };

  // Initialize dropdown data
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const response = await getRoomMasterdropdata({
          Flag: "",
          UserId: userId,
        });

        if (response?.data?.Status === 0) {
          const dropdownItems = response.data.Data.map((item) => ({
            id: item.PropId,
            name: item.Name,
          }));
          setDropdownData(dropdownItems);
          if (dropdownItems.length > 0) {
            setSelectedValue(dropdownItems[0].id);
          } else {
            setDropdownData([]);
            setRows([]);
            toast.info("No properties available");
          }
        }
      } catch (error) {
        toast.error("Error fetching property data");
      }
    };
    fetchDropdownData();
  }, [userId]);

  const getMonthStyle = (value) => {
    switch (value) {
      case "V":
        return { backgroundColor: "green", color: "white" };
      case "B":
        return { backgroundColor: "red", color: "white" };
      case "O":
        return { backgroundColor: "yellow", color: "black" };
      case "A":
        return { backgroundColor: "#00b300", color: "white" }; // Bright green for Available
      case "C":
        return { backgroundColor: "#ff1a1a", color: "white" };
      default:
        return {};
    }
  };

  // Filter rows based on search terms
  const filteredRows = React.useMemo(() => {
    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        return String(value).toLowerCase().includes(term.toLowerCase());
      });
    });
  }, [searchTerms, rows]);

  const renderCell = (value) => {
    if (!value && value !== '') return '';

    const style = getMonthStyle(value);
    return (
      <div style={style}>
        {value}
      </div>
    );
  };

  // Update your formattedRows calculation
  const formattedRows = React.useMemo(() => {
    return rows.map(row => {
      const newRow = { ...row };

      Object.keys(row).forEach(key => {
        if (!BASE_COLUMNS.find(col => col.id === key) && row[key] !== undefined) {
          newRow[key] = renderCell(row[key]);
        }
      });

      return newRow;
    });
  }, [rows]);

  const Filters = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
        <FormControl sx={{ minWidth: 170 }}>
          <InputLabel id="property-select-label">Property</InputLabel>
          <Select
            labelId="property-select-label"
            value={selectedValue}
            onChange={handleDropdownChange}
            label="Property"
            sx={{ height: "40px" }}
          >
            {dropdownData.map((item) => (
              <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
            <DatePicker
              label="From-Date"
              value={dateFrom}
              onChange={setDateFrom}
              format="DD/MM/YYYY"
              sx={{ backgroundColor: "white", width: 150 }}
            />
            <DatePicker
              label="To-Date"
              value={dateTo}
              onChange={setDateTo}
              format="DD/MM/YYYY"
              sx={{ backgroundColor: "white", width: 150 }}
            />
          </Box>
        </LocalizationProvider>
        <Button
          variant="contained"
          onClick={() => { fetchData("") }}
          sx={{ height: "40px", whiteSpace: "nowrap", backgroundColor: "#635bff" }}
        >
          Get Data
        </Button>
        {/* <Button
          variant="contained"
          onClick={() => { fetchData("G") }}
          sx={{ height: "40px", whiteSpace: "nowrap", backgroundColor: "#635bff" }}
        >
          Generate
        </Button> */}
      </Box>
    </Box>
  );

  const handleGenerateCalendar = () => {
    fetchData();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    // navigate('/room-master');
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleLocationclick = () => {
    navigate('/reports/dailysummaryreport', {
      state: {
        permissions: currentPermissions
      }
    });
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const handleRowDoubleClick = () => {
    // navigate('/room-master', { state: { RoomId }} );
  };

  const addButtonStyles = {
    background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
    color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
    borderRadius: "50px",
    padding: "8px 20px",
    boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.3)" : "none",
    transition: "background 0.3s ease",
    "&:hover": {
      background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)"
    }
  };

  return (
    <>
      <Box sx={{ maxWidth: "100vw", overflowX: "hidden" }}>
        <TableComponent
          page={page}
          columns={tableColumns}
          rows={formattedRows}
          title="Reports"
          titleMaster="Bed Report Calender"
          handleClick={handleClick}
          FiltersJsx={Filters}
          filteredRows={filteredRows}
          rowsPerPage={rowsPerPage}
          handleSearchChange={handleSearchChange}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={(e) => setRowsPerPage(+e.target.value)}
          handleRowDoubleClick={handleRowDoubleClick}
          handleLocationclick={handleLocationclick}
          handleHomeClick={handleHomeClick}
          rowStyle={(row) => row.style}
          cellStyle={(columnId) =>
            columnId.startsWith('year_') || columnId.match(/^\d+_.+/)
              ? { padding: '0px', fontSize: '12px', textAlign: 'center' }
              : {}
          }
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          onCellEdit={handleCellEdit}
          editable={true}
          isLoading={isLoading}
        />
      </Box>

      <Box sx={{ display: "flex", mx: 9, mb: 2, gap: 2, alignItems: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#00b300", borderRadius: "4px" }}></Box>
          <Typography variant="body2">A - Available</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#635bff", borderRadius: "4px" }}></Box>
          <Typography variant="body2">B - Booked</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#c971bb", borderRadius: "4px" }}></Box>
          <Typography variant="body2">C - Confirm</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#d17b49", border: "1px solid black", borderRadius: "4px" }}></Box>
          <Typography variant="body2">P - Partial Booking</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#800000", border: "1px solid black", borderRadius: "4px" }}></Box>
          <Typography variant="body2">M - Maintenince</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#47a1ba", border: "1px solid black", borderRadius: "4px" }}></Box>
          <Typography variant="body2">R - Reserved</Typography>
        </Box>
      </Box>
    </>
  );
}    
